var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Clone, E, eo, GetPercentFromXToY, Vector2i } from "js-vextensions";
import keycode from "keycode";
import { runInAction } from "mobx";
import { Button, CheckBox, Column, Div, Pre, Row, Spinner, TextInput } from "react-vcomponents";
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { VMenuItem, VMenuStub } from "react-vmenu";
import { ShowMessageBox } from "react-vmessagebox";
import { ScrollView } from "react-vscrollview";
import { DeleteSeed } from "Server/Commands/DeleteSeed";
import { UpdateBookEvent } from "Server/Commands/UpdateBookEvent";
import { UpdateCharacter } from "Server/Commands/UpdateCharacter";
import { store } from "Store";
import { GetAttributes } from "Store/firebase/attributes";
import { Attribute } from "Store/firebase/attributes/@Attribute";
import { styles } from "Utils/UI/GlobalStyles";
import { GetScreenRect, Observer, Slider, PageContainer } from "vwebapp-framework";
import { AddAttribute } from "../../Server/Commands/AddAttribute";
import { AddBookEvent } from "../../Server/Commands/AddBookEvent";
import { AddSeed } from "../../Server/Commands/AddSeed";
import { DeleteBookEvent } from "../../Server/Commands/DeleteBookEvent";
import { SetBookEventIndex } from "../../Server/Commands/SetBookEventIndex";
import { GetCharacters } from "../../Store/firebase/characters";
import { GetEventIDs_Ordered, GetEventIndex, GetEvents, GetSelectedEvent, GetSelectedEvent_Character } from "../../Store/firebase/events";
import { BookEvent } from "../../Store/firebase/events/@BookEvent";
import { GetSeed, GetSeeds, GetSelectedSeed } from "../../Store/firebase/seeds";
import { Seed } from "../../Store/firebase/seeds/@Seed";
import { SeedDetailsUI } from "./SeedDetailsUI";
let SeedsUI = class SeedsUI extends BaseComponent {
    render() {
        const { bookID } = this.props;
        let characters = GetCharacters(bookID);
        const attributes = GetAttributes();
        const showAllSeeds = store.main.write.showAllSeeds;
        let seeds = GetSeeds(bookID);
        const selectedSeed = GetSelectedSeed(bookID);
        const copiedSeed = store.main.copiedSeedID;
        const events = GetEvents(bookID);
        const eventCountWeight = store.main.write.seeds_eventCountWeight;
        if (bookID == null)
            return React.createElement("div", null, "Please select a book.");
        seeds = showAllSeeds ? seeds : seeds.filter(seed => !events.Any(a => a.seed == seed._key));
        const characterEventCounts = characters.map(char => events.filter(a => a.characters[char._key]).length);
        const characterSimilarities = {};
        if (selectedSeed) {
            for (const character of characters) {
                const sharedAttributes = attributes.filter(a => (character.attributeLevels || {})[a._key] != null && (selectedSeed.attributeLevels || {})[a._key] != null);
                const similarity = sharedAttributes.length == 0 ? 0
                    : 1 - sharedAttributes.map(a => character.attributeLevels[a._key].Distance(selectedSeed.attributeLevels[a._key])).Average();
                characterSimilarities[character._key] = similarity;
            }
        }
        characters = characters.OrderByDescending((char, index) => {
            const similarityScore = characterSimilarities[char._key];
            const eventCountScore = GetPercentFromXToY(characterEventCounts.Max(), characterEventCounts.Min(), characterEventCounts[index]);
            const finalValue = ((1 - eventCountWeight) * similarityScore) + (eventCountWeight * eventCountScore);
            return finalValue;
        });
        return (React.createElement(PageContainer, { preset: "full", scrollable: true, innerStyle: { flexDirection: "row", padding: 10 } },
            React.createElement(Column, { className: "clickThrough", style: { flex: "0 0 200px", height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
                React.createElement(Row, { style: { height: 40, padding: 10 } },
                    React.createElement(Pre, null,
                        "Seeds (",
                        seeds.length,
                        ")"),
                    React.createElement(CheckBox, { text: "All", ml: "auto", value: showAllSeeds, onChange: val => runInAction("SeedsUI.showAllSeeds.onChange", () => store.main.write.showAllSeeds = val) })),
                React.createElement(Row, null,
                    React.createElement(TextInput, { ref: c => this.addSeedEl = c, placeholder: "Add a seed...", style: { width: "100%" }, value: null, delayChangeTillDefocus: true, onKeyDown: e => {
                            if (e.keyCode == keycode.codes.enter) {
                                const newSeed = new Seed({ text: this.addSeedEl.state.editedValue, book: bookID });
                                new AddSeed({ seed: newSeed }).Run();
                            }
                        } })),
                React.createElement(ScrollView, null, seeds.map(seed => {
                    return React.createElement(SeedEntryUI, { key: seed._key, seed: seed, copiedSeed: copiedSeed });
                }))),
            React.createElement(Column, { ml: 10, sel: true, style: { flex: "0 0 250px", height: "100%", flexShrink: 0, background: "rgba(0,0,0,.7)", borderRadius: 10, padding: 10, alignItems: "flex-start", cursor: "auto" } },
                selectedSeed && React.createElement(SeedDetailsUI, { baseData: selectedSeed }),
                React.createElement(Row, { mt: "auto" },
                    React.createElement(Pre, null, "Event count weight:")),
                React.createElement(Row, { style: { width: "100%" } },
                    React.createElement(Slider, { min: 0, max: 1, step: .1, delayChangeTillDefocus: true, value: eventCountWeight, onChange: val => runInAction("SeedsUI.eventCountWeight.onChange", () => store.main.write.seeds_eventCountWeight = val) }))),
            characters.map((char, index) => {
                return (React.createElement(CharacterColumn, { key: char._key, bookID: bookID, character: char, index: index, similarity: characterSimilarities[char._key] }));
            })));
    }
};
SeedsUI = __decorate([
    Observer
], SeedsUI);
export { SeedsUI };
class SeedEntryUI extends BaseComponent {
    render() {
        const { seed, copiedSeed } = this.props;
        return (React.createElement(Row, { onContextMenu: e => e.preventDefault() },
            React.createElement(Button, { text: seed.text, style: { width: "100%" }, onClick: () => {
                    runInAction("SeedEntryUI.selectedSeed.onChange", () => store.main.write.selectedSeed = seed._key);
                } }),
            React.createElement(VMenuStub, { preOpen: e => e.noVMenu != true },
                React.createElement(VMenuItem, { text: copiedSeed ? React.createElement("span", null,
                        "Copy ",
                        React.createElement("span", { style: { fontSize: 10, opacity: .7 } }, "(right-click to clear)")) : "Copy", style: styles.vMenuItem, 
                    //enabled={ForCopy_GetError(userID, map, node) == null} title={ForCopy_GetError(userID, map, node)}
                    onClick: e => {
                        //e.persist();
                        runInAction("SeedEntryUI.copiedSeedID.onChange", () => store.main.copiedSeedID = e.button == 0 ? seed._key : null);
                    } }),
                React.createElement(VMenuItem, { text: "Delete" //enabled={ForDelete_GetError(userID, map, node) == null} title={ForDelete_GetError(userID, map, node)}
                    , style: styles.vMenuItem, onClick: e => {
                        if (e.button != 0)
                            return;
                        ShowMessageBox({
                            title: `Delete "${seed.text}"`, cancelButton: true,
                            message: `Delete the seed "${seed.text}"?`,
                            onOK: () => {
                                new DeleteSeed({ id: seed._key }).Run();
                            },
                        });
                    } }))));
    }
}
let CharacterColumn = class CharacterColumn extends BaseComponentPlus({}, {}) {
    render() {
        const { bookID, character, index, similarity } = this.props;
        let events = GetEvents(bookID).filter(a => a.characters[character._key]);
        const attributes = GetAttributes();
        const copiedSeed = store.main.copiedSeedID;
        const selectedEvent = GetSelectedEvent();
        const selectedEvent_character = GetSelectedEvent_Character();
        const eventIDs_ordered = GetEventIDs_Ordered(character._key);
        const characters_showAttributes = store.main.write.characters_showAttributes;
        const characters_showDescription = store.main.write.characters_showDescription;
        events = events.OrderBy(a => eventIDs_ordered.indexOf(a._key).IfN1Then(Number.MAX_SAFE_INTEGER));
        return (React.createElement(Column, { className: "clickThrough", ml: 10, style: { flex: "0 0 200px", height: "100%", background: "rgba(0,0,0,.7)", borderRadius: 10 } },
            React.createElement(Row, { style: { height: 40, padding: 10 } },
                React.createElement(Pre, null, character.name),
                React.createElement(Pre, { ml: "auto" }, events.length)),
            characters_showAttributes
                && React.createElement(Row, null,
                    React.createElement(Pre, null, "Attributes: "),
                    React.createElement(Button, { text: "+", onClick: () => {
                            const attribute = new Attribute({ name: "todo" });
                            new AddAttribute({ attribute }).Run();
                        } }),
                    React.createElement(Pre, null,
                        " (sim: ",
                        similarity,
                        ")")),
            characters_showAttributes
                && React.createElement(Column, null, attributes.map(attr => {
                    const hasAttribute = (character.attributeLevels || {})[attr._key] != null;
                    return (React.createElement(Row, { key: attr._key, className: "sliderHandleAbove", ml: 10, mr: 10, style: { position: "relative", width: 180 } },
                        React.createElement(Slider, { min: 0, max: 1, step: .1, enabled: hasAttribute, delayChangeTillDefocus: true, value: (character.attributeLevels || {})[attr._key], onChange: val => {
                                const newAttributeLevels = Clone(character.attributeLevels || {});
                                newAttributeLevels[attr._key] = val;
                                new UpdateCharacter({ id: character._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                            } }),
                        React.createElement(CheckBox, { value: hasAttribute, onChange: val => {
                                const newAttributeLevels = Clone(character.attributeLevels || {});
                                if (val)
                                    newAttributeLevels[attr._key] = 0;
                                else
                                    delete newAttributeLevels[attr._key];
                                new UpdateCharacter({ id: character._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                            } }),
                        React.createElement(Div, { style: {
                                position: "absolute", left: 0, right: 0, top: 0, bottom: 0, textAlign: "center", pointerEvents: "none",
                                color: "black", fontWeight: "bold", textShadow: "-1px 0 yellow, 0 1px yellow, 1px 0 yellow, 0 -1px yellow",
                            } }, attr.name)));
                })),
            characters_showDescription
                && React.createElement(Row, null,
                    React.createElement(Button, { text: character.description, style: { width: "100%" } })),
            React.createElement(ScrollView, { style: { flex: 1 } },
                React.createElement(Column, { style: { minHeight: "100%", background: "rgba(255,255,255,.3)" }, onContextMenu: e => e.preventDefault() },
                    events.filter(a => a.placeholderCount == null).map(event => {
                        return (React.createElement(EventUI, { key: event._key, event: event, character: character }));
                    }),
                    React.createElement(VMenuStub, { preOpen: e => e.noVMenu != true }, copiedSeed
                        && React.createElement(VMenuItem, { text: "Paste seed as event", style: styles.vMenuItem, onClick: async (e) => {
                                if (e.button != 0)
                                    return;
                                const newEvent = new BookEvent({ book: bookID, seed: copiedSeed, characters: { [character._key]: { _: true } } });
                                await new AddBookEvent({ event: newEvent }).Run();
                            } })))),
            selectedEvent
                && React.createElement(EventDetailsBox, { event: selectedEvent, character: selectedEvent_character })));
    }
};
CharacterColumn = __decorate([
    Observer
], CharacterColumn);
let EventUI = class EventUI extends BaseComponentPlus({}, { editing: false }) {
    render() {
        const { event, character } = this.props;
        const seed = GetSeed(event.seed);
        const copiedSeed = store.main.copiedSeedID;
        const selectedEvent = GetSelectedEvent();
        const { editing } = this.state;
        const text = event.text || (seed || eo).text;
        const selected = selectedEvent == event;
        return (React.createElement(Row, { onContextMenu: e => { e.preventDefault(); e["noVMenu"] = true; } },
            React.createElement(Button, { text: text, style: E({ width: "100%" } /*!event.indexAccepted && {background: "rgba(130,100,110,.6)"}*/), onClick: e => {
                    const buttonRect = GetScreenRect(e.target);
                    runInAction("EventUI.onClick", () => {
                        store.main.write.selectedEvent = !selected ? event._key : null;
                        store.main.write.selectedEvent_character = character._key;
                        store.main.write.selectedEvent_position = new Vector2i(buttonRect.Right, buttonRect.Top);
                    });
                } }),
            React.createElement(VMenuStub, { preOpen: e => e.noVMenu != true },
                copiedSeed
                    && React.createElement(VMenuItem, { text: "Paste seed as event", style: styles.vMenuItem, onClick: async (e) => {
                            if (e.button != 0)
                                return;
                            const newEvent = new BookEvent({ book: event.book, seed: copiedSeed, characters: { [character._key]: { _: true } } });
                            await new AddBookEvent({ event: newEvent }).Run();
                        } }),
                React.createElement(VMenuItem, { text: "Delete" //enabled={ForDelete_GetError(userID, map, node) == null} title={ForDelete_GetError(userID, map, node)}
                    , style: styles.vMenuItem, onClick: e => {
                        if (e.button != 0)
                            return;
                        ShowMessageBox({
                            title: `Delete "${text}"`, cancelButton: true,
                            message: `Delete the event "${text}"?`,
                            onOK: () => {
                                new DeleteBookEvent({ id: event._key }).Run();
                            },
                        });
                    } }))));
    }
};
EventUI = __decorate([
    Observer
], EventUI);
let EventDetailsBox = class EventDetailsBox extends BaseComponentPlus({}, {}) {
    render() {
        const { event, character, positionAbsolutely } = this.props;
        const seed = GetSeed(event.seed);
        const position = store.main.write.selectedEvent_position || new Vector2i(0, 0);
        const eventIndex = GetEventIndex(character._key, event._key);
        const text = event.text || (seed || eo).text;
        const backgroundColor = "40,60,80";
        return (React.createElement(Column, { style: E({ padding: 5, background: /*"rgba(0,0,0,.7)"*/ `rgba(${backgroundColor},.7)`, borderRadius: 5, boxShadow: "rgba(0,0,0,1) 0px 0px 2px" }, positionAbsolutely != false && { position: "fixed", left: position.x, top: position.y, zIndex: 11 }) },
            React.createElement(Row, { mt: 5 },
                React.createElement(Pre, null,
                    "ID: ",
                    event._key)),
            React.createElement(Row, { style: { position: "relative" } },
                React.createElement(Pre, null, "Seed: "),
                React.createElement(Spinner, { value: event.seed || 0, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { seed: val != 0 ? val : undefined } }).Run();
                    } })),
            React.createElement(Row, { style: { position: "relative" } },
                React.createElement(Pre, null, "Text: "),
                React.createElement(TextInput, { value: text, delayChangeTillDefocus: true, useEscape: true, onChange: val => {
                        new UpdateBookEvent({ id: event._key, updates: { text: val } }).Run();
                    } })),
            React.createElement(Row, { style: { position: "relative" } },
                React.createElement(Pre, null, "Order: "),
                React.createElement(Spinner, { value: eventIndex || undefined, onChange: val => {
                        new SetBookEventIndex({ characterID: character._key, eventID: event._key, index: val }).Run();
                    } }))));
    }
};
EventDetailsBox = __decorate([
    Observer
], EventDetailsBox);
export { EventDetailsBox };
